import { isMobile } from '@/lib/device'
const devicePath = !isMobile ? 'pc' : 'mobile'
export default [
  {
    path: '/teamwork/invitejoinfirst',
    name: 'InviteJoinFirst',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/${devicePath}/team/Invite`)
  },
  {
    path: '/teamInvite/success',
    name: 'TeamInviteSuccess',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/${devicePath}/team/InviteJoinSuccess`)
  },
  {
    path: '/teamInvite/lose',
    name: 'TeamInviteLose',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/${devicePath}/team/InviteJoinLose`)
  },
  {
    path: '/teamInvite/login',
    name: 'TeamInviteLogin',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/${devicePath}/team/InviteJoinLogin`)
  },
  {
    path: '/teamInvite/result',
    name: 'TeamInviteResult',
    component: () => import(/* webpackChunkName: "pc-base" */ `@/${devicePath}/team/InviteJoinResult`)
  }
]
